import React, { Component } from 'react';
import {
    CardNumberElement,
    CardExpiryElement,
    CardCVCElement,
    PostalCodeElement,
    injectStripe
} from 'react-stripe-elements';
import { connect } from 'react-redux';
import { getCustomerCreditCards, saveCustomerCreditCard, saveButtonActive, saveButtonDisable } from '../actions/PaymentAction';
import { toast } from 'react-toastify'
import { qpClosemodal } from "../utils/misc";

const createOptions = (fontSize, padding) => {
    return {
        style: {
            base: {
                fontSize,
                color: '#424770',
                letterSpacing: '0.025em',
                fontFamily: 'Source Code Pro, monospace',
                '::placeholder': {
                    color: '#aab7c4',
                },
                ...(padding ? { padding } : {}),
            },
            invalid: {
                color: '#9e2146',
            },
        },
    };
};

class StripeCardForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stripeToken: "",
            cardInfo: {},
            buttonDisabled: false
        }
    }

    componentWillReceiveProps(nextProps) {

        this.setState({
            buttonDisabled: nextProps.state.buttonDisable
        })
    }

    handleNumberReady = (e) => {
        this._numberElement = e;
    };

    handleExpiryReady = (e) => {
        this._ExpiryElement = e;
    }

    handleCVVReady = (e) => {
        this._CvvElement = e;
    }

    handlePostalCodeReady = (e) => {
        this._PostalCodeElement = e;
    }

    handleSubmit = (ev) => {
        ev.preventDefault();

        this.props.saveButtonActive()

        if (this.props.stripe) {
            console.log("stripe", this.props.stripe);
            this.props.stripe
                .createToken()
                .then((payload) => {

                    if (payload.error != null) {

                        toast.error('Card Save failed', {
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true
                        });

                    }
                    else {

                        this.props.saveCustomerCreditCard(payload.token.id).then(result => {

                            if (result.statusCode !== 200) {
                                toast.error('Error Saving Card', {
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true
                                });

                                this.props.saveButtonDisable()

                            } else {

                                toast.success('Card Successfully Saved', {
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true
                                });

                                qpClosemodal("#AddCardModal")

                                this._numberElement.clear();
                                this._ExpiryElement.clear();
                                this._CvvElement.clear();
                                this._PostalCodeElement.clear();

                                this.props.getCustomerCreditCards()
                            }
                           
                        });

                    }

                });
        } else {
            console.log("Stripe.js hasn't loaded yet.");
        }
    };

    clearCard = () => {

        this._numberElement.clear();
        this._ExpiryElement.clear();
        this._CvvElement.clear();
        this._PostalCodeElement.clear();
    }

    render() {

        if (this.props.card != this.state.cardInfo && this.state.cardInfo.length === 0) {
            this.setState({ cardInfo: this.props.card }, () => {
                console.log("statechild", this.state.cardInfo)
            })
        }

        return (
            <form onSubmit={this.handleSubmit.bind(this)} key={this.state.treedigit}>
                <div className="row">
                    <div className="col-md-12">
                        <label> Card Number </label>
                        <div className="form-group">
                            <CardNumberElement
                                className="form-control"
                                onReady={this.handleNumberReady}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label> Exp. Date (Ex. 12/20)</label>
                            <CardExpiryElement
                                className="form-control"
                                onReady={this.handleExpiryReady}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label> 3-digit number </label>
                        <CardCVCElement
                            className="form-control"
                            onReady={this.handleCVVReady}
                            {...createOptions(this.props.fontSize)}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label> Adress Zip Code </label>
                        <PostalCodeElement
                            className="form-control"
                            onReady={this.handlePostalCodeReady}
                            {...createOptions(this.props.fontSize)}
                        />
                    </div>
                </div>
                <button ref="btn" className="btn btn-success" disabled={this.state.buttonDisabled === true ? "disabled" : ""} style={{ textDecoration: "none" }}>Save Card</button>
                <button type="button" ref="btn" className="btn btn-primary" onClick={this.clearCard} >Clear Card</button>
            </form>
        );
    }
}

const mapStateToProps = state => {
    return {
        state: state.paymentData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCustomerCreditCards: () => dispatch(getCustomerCreditCards()),
        saveCustomerCreditCard: (id) => dispatch(saveCustomerCreditCard(id)),
        saveButtonActive: () => dispatch(saveButtonActive()),
        saveButtonDisable: () => dispatch(saveButtonDisable())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectStripe(StripeCardForm));


// WEBPACK FOOTER //
// ./src/components/StripeCardForm.js